import mappedItemTypes from 'services/items/mappedItemTypes';
import { PortfolioItemSelectStep } from '../PortfolioItemSelectStep';
import { PCW_STEPS } from '../constants';

export function AddAssetsStep() {
    return (
        <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_ADD_ASSETS_STEP_ID}
            itemTypeIds={[
                mappedItemTypes.BATTERY_STORAGE.id,
                mappedItemTypes.GENERATION_ASSET.id,
                mappedItemTypes.WIND_ASSET.id,
            ]}
        />
    );
}
